var map = {
	"./logo-footer.png": 105,
	"./logo.png": 106,
	"./pp.jpg": 26,
	"./slide.png": 107,
	"./teacher.png": 108,
	"./video-1.png": 109,
	"./video-2.png": 110,
	"./video-3.png": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;